import { actionType } from './actions';

const initialState = {
    editStateData: {
        isState: '',
        hasInitialNfForm: '',
        hasRenewalNfForm: '',
        hasAmendmentNfForm: '',
        hasTerminationNfForm: '',
        hasInitialU2Form: '',
        hasRenewalU2Form: '',
        hasAmendmentU2Form: '',
        hasTerminationU2Form: '',
        renewalCycleType: '',
        isElectronicFiling: '',
        paymentType: '',
        checkPayee: '',
        bulkChecksPermitted: '',
        permitNumberType: '',
        needSalesReports: '',
        renewalFeeCalculationType: '',
        renewalFeeCalculationTypeParameters: '',
        terminationFee: '',
        stateId: '',
        name: '',
        code: '',
        stateFilingStatus: '',
        fundFilingType: '',
        initialFeeCalculationType: '',
        initialFeeCalculationTypeParameters: '',
        minimumFee: ''
    },
    states: [],
    selectedItemData: {},
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_STATE_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_STATE_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_STATES: {
            return {
                ...state,
                states: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_STATE: {
            return {
                ...state,
                editStateData: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.EDIT_STATE: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_STATE_SELECTED: {
            return {
                ...state,
                selectedItemData: action.payload
            };
        }

        case actionType.UPDATE_EDIT_STATE_PAYLOAD: {
            return {
                ...state,
                editStateData: action.payload
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/state/reducers.js